import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import { ToastContainer } from 'react-toastify';
import ResiduesList from './ResiduesList';

const Residues = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '/residue/dashboard', label: 'Residuos', icon: 'icon-recycle' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Residuos' links={breadcrumbLinks} icon={'icon-trash'} />
					<ResiduesList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Residues;
